
<script>
  import { createEventDispatcher, onMount, onDestroy } from 'svelte';
  import { Capacitor } from '@capacitor/core';
  import backarrow from './assets/backarrow.png';
	
  const dispatch = createEventDispatcher();
  export let phoneNumber = '';
  export let fcmToken = '';

  let otp = '';
  let message = '';
  let isOtpValid = false;
  let isLoading = false;
  const isWeb = !Capacitor.isNativePlatform();

  let isListening = false;
  let isOverlayVisible = false;
  let overlayMessage = '';
  let isLoginSuccess = false;

  onMount(() => {
    if (!isWeb) {
      startListeningSMS();
    }
  });

  onDestroy(() => {
    if (!isWeb && isListening) {
      stopListening();
    }
  });


  function startListeningSMS() {
    isListening = true;
    showOverlay('Checking SMS');
    
    setTimeout(() => {
      if (isListening) {
        stopListening();
        message = 'Please enter OTP.';
      }
    }, 15000);

    if (window.cordova && window.cordova.plugins && window.cordova.plugins.smsRetriever) {
      window.cordova.plugins.smsRetriever.startWatching(
        (result) => {
          const receivedMessage = result.Message;
          const extractedOtp = extractOtp(receivedMessage);
          if (extractedOtp) {
            otp = extractedOtp;
            verifyOtp(extractedOtp);
          }
          stopListening();
        },
        (error) => {
          console.error('Error in SMS listening:', error);
          stopListening();
        }
      );
    } else {
      console.error('SMS Retriever plugin not found');
      stopListening();
    }
  }

  function stopListening() {
    isListening = false;
    hideOverlay();
    if (window.cordova && window.cordova.plugins && window.cordova.plugins.smsRetriever) {
      window.cordova.plugins.smsRetriever.stopWatching();
    }
  }

  function extractOtp(smsText) {
    const otpMatch = smsText.match(/^(\d{4})/);
    return otpMatch ? otpMatch[1] : null;
  }

  async function verifyOtp(otpToVerify = otp) {
    showOverlay('Verifying OTP');
    try {
      const response = await fetch('https://groupfruits.online/authentication/api/MSG91LoginView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phone: phoneNumber,
          otp: otpToVerify
        })
      });
      const data = await response.json();
      if (response.ok && data.access) {
        localStorage.setItem('accessToken', data.access);
        localStorage.setItem('refreshToken', data.refresh);
        if (!isWeb) {
          await updateUserProfile(data.access);
        }
        showLoginSuccess();
        setTimeout(() => {
          if (data.fullName === null) {
            dispatch('loginSuccessNoName', data);
          } else if (data.delivery_point === null) {
            dispatch('loginSuccessNoPoint', data);
          } else {
            dispatch('loginSuccess', data);
          }
        }, 2000);
      } else {
        hideOverlay();
        message = 'Invalid OTP. Please try again.';
      }
    } catch (error) {
      hideOverlay();
      message = 'Verification failed. Please try again.';
    }
  }

  async function updateUserProfile(accessToken) {
    const jwtToken = `JWT ${accessToken}`;
    try {
      const updateProfileResponse = await fetch('https://groupfruits.online/users/api/UpdateUserProfileView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': jwtToken
        },
        body: JSON.stringify({ fcm_token: fcmToken })
      });
      const updateProfileData = await updateProfileResponse.json();
      console.log(updateProfileData.message);
    } catch (error) {
      console.error('Error updating user profile:', error);
    }
  }

  function goBack() {
    dispatch('backToLogin');
  }

  function showOverlay(message) {
    isOverlayVisible = true;
    overlayMessage = message;
  }

  function hideOverlay() {
    isOverlayVisible = false;
    overlayMessage = '';
  }

  function showLoginSuccess() {
    isLoginSuccess = true;
    showOverlay('Login Successful!');
  }

  $: {
    isOtpValid = /^\d{4}$/.test(otp);
    if (isOtpValid && !isLoading) {
      verifyOtp();
    }
  }
</script>


<style>

* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}


.container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  font-family: 'Roboto', sans-serif;
  overflow: hidden;
}


.otp-form {
  max-width: 400px;
  width: 90%; /* Use percentage instead of fixed width */
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow-y: auto; /* Allow vertical scrolling if content is too tall */
  max-height: 100vh; /* Limit the height to the viewport height */
}

  h2 {
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #333;
    margin-bottom: 20px;
  }


  p {
    text-align: center;
  }

  .otp-input {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
  }

  .otp-input input {
    width: 100%;
    height: 50px;
    font-size: 24px;
    text-align: center;
    border: 1px solid #ddd;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s ease;
  }

  .otp-input input:focus {
    border-color: #6c63ff;
  }

  button {
    width: 100%;
    padding: 16px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    position: relative;
  }

.verify-btn {
  background-color: #6c63ff;
  color: #fff;
  transition: background-color 0.3s ease;
}

.verify-btn.highlight {
  background-color: #ff4081; /* Bright pink color */
}

.verify-btn:hover,
.verify-btn:focus {
  background-color: #5a4ff3;
}

.verify-btn:disabled {
  background-color: #ddd;
  color: #888;
  cursor: not-allowed;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fff;
  justify-content: center;
}

.back-btn img {
  width: 20px;
  height: 20px;
}

  .back-btn:hover,
  .back-btn:focus {
    color: #5a4ff3;
  }

  .message {
    text-align: center;
    color: #f44336;
    margin-top: 20px;
  }

  .loader {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 16px;
  }

  .loader div {
    position: absolute;
    top: 6px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  .loader div:nth-child(1) {
    left: 8px;
    animation: loader-dot1 0.6s infinite;
  }

  .loader div:nth-child(2) {
    left: 8px;
    animation: loader-dot2 0.6s infinite;
  }

  .loader div:nth-child(3) {
    left: 32px;
    animation: loader-dot2 0.6s infinite;
  }

  .loader div:nth-child(4) {
    left: 56px;
    animation: loader-dot3 0.6s infinite;
  }

  @keyframes loader-dot1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes loader-dot2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }

  @keyframes loader-dot3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }


.hash-button {
  margin-top: 15px;
  width: 100%;
  background-color: #4CAF50;
  color: white;
  padding: 15px;
  font-size: 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.hash-button:hover {
  background-color: #45a049;
}


.listen-sms-button {
  margin-top: 15px;
  width: 100%;
  background-color: #4CAF50;
  color: white;
  padding: 15px;
  font-size: 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.listen-sms-button:hover {
  background-color: #45a049;
}

.listen-sms-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 80%;
}

.dialog-content h2 {
  margin-top: 0;
}

.dialog-content button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}


  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .overlay-content {
    text-align: center;
    color: #333;
  }

  .overlay h2 {
    font-size: 24px;
    margin-bottom: 20px;
    color: #333;
  }

  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  

  .dot-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .dot {
    width: 12px;
    height: 12px;
    background-color: #6c63ff;
    border-radius: 50%;
    margin: 0 8px;
    animation: dot-pulse 1.4s infinite ease-in-out;
  }

  .dot:nth-child(1) {
    animation-delay: -0.32s;
  }

  .dot:nth-child(2) {
    animation-delay: -0.16s;
  }

  @keyframes dot-pulse {
    0%, 80%, 100% { 
      transform: scale(0);
    }
    40% { 
      transform: scale(1);
    }
  }

  
  .success-message {
    color: #4CAF50;
    font-size: 28px;
    font-weight: bold;
    margin-top: 20px;
  }
  
</style>




<div class="container">
  <div class="otp-form">
    <button class="back-btn" on:click={goBack}>
      <img src={backarrow} alt="Back" width="20" height="20" />
    </button>

    <h2>Verify OTP</h2>
    <p>Enter the OTP sent to {phoneNumber}</p>
    <div class="otp-input">
      <input type="text" bind:value={otp} maxlength="4" inputmode="numeric" />
    </div>

    <button 
      class="verify-btn" 
      disabled={!isOtpValid || isLoading} 
      on:click={() => verifyOtp()}
    >
      Verify
    </button>

    {#if isListening}
      <p>Listening for SMS...</p>
    {/if}

    {#if message}
      <p class="message">{message}</p>
    {/if}
  </div>
</div>

{#if isOverlayVisible}
  <div class="overlay">
    <div class="overlay-content">
      <div class="dot-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <h3>{overlayMessage}</h3>
      {#if isLoginSuccess}
        <p class="success-message">Welcome!</p>
      {:else}
        <p>Please Wait...</p>
      {/if}
    </div>
  </div>
{/if}

